import { httpRequest } from "../../../http";

export interface SubresourceItem {
  id: string;
  name: string;
}

export type NetworkSubresources = Record<string, SubresourceItem[]>;

export class CommandGetSubresources {
  async run(resourceId: number): Promise<NetworkSubresources> {
    try {
      const response = await httpRequest<NetworkSubresources>(
        `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content_network/resources/${resourceId}/subresources/`,
        { method: "GET" },
      );
      return response;
    } catch (error) {
      console.error("Error fetching subresources:", error);
      throw error;
    }
  }
}
